import BurgerMenuContainer from './BurgerMenu.container';
import BurgerMenu from './BurgerMenu';
export default BurgerMenuContainer(BurgerMenu);
//# sourceMappingURL=index.js.map